import { getBrowserLocales, getCurrentLocale } from '@mc/i18n'
import { metrics } from '@mc/rum'
import { TRACK_PROPS } from '@mc/track-event'
import { PERSONA_CWV_ON_LOAD_EXP_KEY } from '../experiments'
import createEventId from '../tracking/interactors/createEventId'
import createOrGetVisitSessionIdFromCookie from '../tracking/interactors/createOrGetVisitSessionIdFromCookie'
import getAnonymousId from '../tracking/interactors/getAnonymousId'
import getFacebookBrowserId from '../tracking/interactors/getFacebookBrowserId'
import getFacebookClickId from '../tracking/interactors/getFacebookClickId'
import { logSegmentCalls } from '../tracking/utils'

type MetricData = {
  name: string
  value: number
  [k: string]: string | number | undefined
}

const server = 'persona'
export function reportCoreWebVitals(metric: MetricData) {
  if (
    typeof window !== 'undefined' &&
    window &&
    typeof window.analytics?.track === 'function'
  ) {
    const { search, pathname: path, href: url } = window.location
    const { referrer, title } = document
    const pageProperties = {
      ...(referrer && { referrer }),
      title,
      url,
      path,
      search,
    }
    const integrations = {
      All: true,
      Amplitude: false,
      'Facebook Pixel': false,
      'On Call Google Tag Manager': false,
    }
    const options = {
      server_by: server,
      integrations,
      vendor_integrations: integrations,
      page: pageProperties,
    }

    const {
      is_logged_in: isLoggedIn,
      region,
      country,
      userId,
    } = window.__NEXT_DATA__.props.pageProps?.userAttributes || {}

    const properties = {
      ...metric,
      anonymousId: getAnonymousId(),
      ...(isLoggedIn && { userId }),
      path,
      user_locale: getCurrentLocale(),
      native_locale: getBrowserLocales(),
      geo: country,
      region,
      event_id: createEventId(),
      platform: 'web',
      fbp: getFacebookBrowserId(),
      fbc: getFacebookClickId(),
      [TRACK_PROPS.VISIT_SESSION_ID]: createOrGetVisitSessionIdFromCookie(),
    }
    logSegmentCalls('track', 'Core Web Vital', properties, options)
    window.analytics.track('Core Web Vital', properties, options)
  }
}

export const initCoreWebVitals = () => {
  if (
    typeof window !== 'undefined' &&
    window &&
    // Couldn't find a better way to check if the experiment is enabled - AB
    window.__NEXT_DATA__.props.pageProps.experiments[
      PERSONA_CWV_ON_LOAD_EXP_KEY
    ] === 'variant_1'
  ) {
    metrics('Persona Core Web Vitals', (metric) => {
      reportCoreWebVitals(metric)
    })
  }
}
